import axios from 'axios'
export default {
    state: {
        currentRoute: null
    },

    mutations: {
        setCurrentRoute(state, currentRoute) {
            state.currentRoute = currentRoute
        }
    }
}